module.exports = __webpack_public_path__ + "img/0-sm.edad4bc2.jpg";